/*
 * Project: BookingEngine
 * Module: components/icons/ArrowIcon.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';

const rotate = (direction) => {
  let angle;
  switch (direction) {
    case 'down':
      angle = '0.0000';
      break;
    case 'left':
      angle = '-90.0000';
      break;
    case 'up':
      angle = '-180.0000';
      break;
    case 'right':
    default:
      angle = '-270.0000';
      break;
  }
  return `rotate(${angle})`;
};

const ArrowIcon = (props) => (
  <svg className={`svg-icon arrow-icon arrow-icon__${props.direction}`} viewBox="0 0 14 8" width="12" height="12"
       version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform={`translate(7.000000, 4.000000) ${rotate(props.direction)} translate(-20.000000, -20.000000)`}>
        <g className="grey-path" fillRule="evenodd">
          <polygon points="25.524029 16 27 17.3930873 20 24 13 17.3930873 14.475971 16 20 21.2138253" />
        </g>
      </g>
    </g>
  </svg>
);

ArrowIcon.propTypes = {
  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']).isRequired,
};

export default ArrowIcon;
